import Quill from 'quill';

const Parchment = Quill.import('parchment');

const FontSize = new Parchment.Attributor.Style('customFontSize', 'font-size', {
  scope: Parchment.Scope.INLINE,
});

export default FontSize;
